/**
 * Converts an array of MIME types to a comma separated string for display.
 * @param {Array} types List of MIME types
 * @return {string}
 */
const getLabelFromMimeTypes = (types: string[] = []): string =>
    types
        .map(type => {
            switch (type) {
                case 'video/mp4':
                    return 'MP4'
                case 'video/mov':
                    return 'MOV'
                case 'image/png':
                    return 'PNG'
                case 'image/gif':
                    return 'GIF'
                case 'image/jpeg':
                    return 'JPG'
                default:
                    return ''
            }
        })
        .filter(value => !!value)
        .join(', ')

export default getLabelFromMimeTypes
